import { useEffect } from "react";

export const useSiteBranding = (pageTitle, websiteData) => {
  useEffect(() => {

    const companyName = websiteData?.home_config?.companyName || "Ezy Freight Logistics";
    const faviconURL = websiteData?.home_config?.faviconURL || "/favicon.png";

    console.log('faviconURL:', faviconURL);

    if (companyName) {
      document.title = pageTitle ? `${pageTitle} - ${companyName}` : companyName;
    }

    if (faviconURL) {
      const selectors = [
        "link[rel='icon']",
        "link[rel='shortcut icon']",
        "link[rel='apple-touch-icon']",
      ];

      selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((link) => {
          link.href = faviconURL;
        });
      });

      // Fallback: create one if none exist at all
      if (!document.querySelector("link[rel~='icon']")) {
        const link = document.createElement("link");
        link.rel = "icon";
        link.href = faviconURL;
        document.head.appendChild(link);
      }
    }
  }, [pageTitle, websiteData]);
};